import styled from "styled-components";

export const Blur = styled.div`
  filter: blur(0.4rem);
`;
